import { Link } from "react-router-dom";
import { useEffect } from "react";
import { tricksArray } from "../data/tricks";
import { PageProps } from "../types/PageProps";
import { groupBy } from "lodash";

export default function Tricks({ setActive }: PageProps) {
  useEffect(() => {
    setActive("Tricks");
  });

  const tricksGroupedByFirstLetter = Object.entries(groupBy(tricksArray, (value) => value.name[0]));

  return (
    <>
      <h1 className="heading">Tricks</h1>

      <p className="page-description">All Paper Mario Speedrun Tricks organized alphabetically.</p>
      <div className="tricks-list">
        {tricksGroupedByFirstLetter.map(([character, tricks]) => (
          <ul className="index-list" key={character}>
            <p className="tricks-title">{character.toUpperCase()}</p>
            {tricks.map((trick, j) => (
              <li className="list-link" key={`${trick.name}`}>
                <Link to={`/Tricks/${trick.path}`}>{trick.name}</Link>
              </li>
            ))}
          </ul>
        ))}
      </div>
    </>
  );
}
